export const notDiseaseFund = (fundId) => {
  const serviceFundIds = ["8101"];

  if (serviceFundIds.includes(fundId.toString())) {
    return true;
  } else {
    return false;
  }
};

export const fundStatusColor = (disease, background = false) => {
  const downcasedStatus = (disease.Fund_Status || "").toLowerCase();

  switch (downcasedStatus) {
    case "open":
      // FIXME-799
      // if (disease.IsRenewalOnly || (disease.FundCriteria || {}).IsRenewalOnly) {
      //   return "status-purple";
      // } else {
      return "status-green";
    // }
    case "closed, wait list available":
      if (background) {
        return "status-darkRed";
      } else {
        return "status-red";
      }
    case "closed":
      if (background) {
        return "status-darkRed";
      } else {
        return "status-red";
      }
    case "open to wait list only":
      return "status-orange";
    default:
      return null;
  }
};

export const fundStatusLabel = (disease) => {
  const downcasedStatus = (disease.Fund_Status || "").toLowerCase();

  switch (downcasedStatus) {
    case "open":
      // FIXME-799
      // if (disease.IsRenewalOnly || (disease.FundCriteria || {}).IsRenewalOnly) {
      //   return "Re-Enrollment Only";
      // } else {
      return "Open";
    // }
    case "closed, wait list available":
      return "Closed";
    case "closed":
      return "Closed";
    case "open to wait list only":
      return "Wait List Only";
    default:
      return null;
  }
};
